// Portfolio Site Initialization

import React, { createContext, useContext, ReactNode } from 'react';
import type { SectionTokenClasses } from '../../components/Modular/ModularTypes/SectionSettings';
import type { UnitTokenClasses } from '../../components/Modular/ModularTypes/UnitSettings';
import type { MicroUnitTokenClasses } from '../../components/Modular/ModularTypes/MicroUnitSettings';

interface LayoutContextProps {
  context: {
    unit?: UnitTokenClasses;
    section?: SectionTokenClasses;
    microUnit?: MicroUnitTokenClasses;
    [key: string]: any;
  };
}

// Layout Context Setup
export const LayoutContext = createContext<LayoutContextProps>({
  context: {},
});

interface LayoutProviderProps extends Partial<LayoutContextProps> {
  children: ReactNode;
}

export const useLayout = () => useContext(LayoutContext);

export const LayoutProvider: React.FC<LayoutProviderProps> = ({
  children,

  context = {},
}) => {
  return (
    <LayoutContext.Provider value={{ context }}>
      {children}
    </LayoutContext.Provider>
  );
};
